export default __webpack_public_path__ + "img/arrow.52566242.svg";